import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup } from 'barnyard/components';
import ProductLinesSelect from '~/app/corporate/core/containers/ProductLinesSelect';


const InlineProductLinesSelect = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={ProductLinesSelect}
      optionFilterProp='name'
      useNative={false}
      placeholder='Select product lines...'
      {...other}
    />
  );
};

InlineProductLinesSelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineProductLinesSelect.defaultProps = {
  label: 'Product Lines',
  description: 'Product Lines to be included'
};

export default memo(InlineProductLinesSelect);
